import { Component, OnInit } from '@angular/core';
import { BuyerUsersReportService } from '../../../services/buyerUsersReport.service';
import { getFormatedDate , formatData} from './utils';

@Component({
  selector: 'app-buyerUsersReport-transactions',
  templateUrl: './buyerUsersReport.component.html',
  styleUrls: ['./buyerUsersReport.component.scss'],
})
export class BuyerUsersComponent implements OnInit {
  totalEntries: number = 0;
  limit: number = 0;

  displayTableColumns: { [key: string]: string } = {
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    balance: 'Balance',
    salesCount: 'Sales Count',
    referralCount: 'Referral Count',
    referralCode: 'Referrer Code',
    lastSignIn: 'Last SignIn',
    lastSuccesfullPayment: 'Last Succesfull Payment',
  };

  tableColumns = [
    'name',
    'email',
    'phone',
    'balance',
    'salesCount',
    'referralCount',
    'referralCode',
    'lastSignIn',
    'lastSuccesfullPayment',
  ];
  buyerUsersReportData: any[] = [];
  totalNumberOfRecords = 0;
  requestBody: any = {};
  loading = false;
  selectFilters = [];

  constructor(public buyerUsersReportService: BuyerUsersReportService) {}

  async ngOnInit() {
    this.buyerUsersReportService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.requestBody.filterOptions = {};
    await this.updateTable();
  }

  async updateTable() {
    this.buyerUsersReportService.activateLoader();
    this.buyerUsersReportService.setParams(this.requestBody);
    const report = await this.buyerUsersReportService.make();
    const data = formatData(report.result)
    this.buyerUsersReportData = data;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
      if (this.requestBody.filterOptions) {
        let createdAt = this.requestBody.filterOptions.createdAt;
        this.requestBody.filterOptions.createdAt = getFormatedDate(
          createdAt.startDate,
          createdAt.endDate
        );
      }
    } else {

      this.requestBody.filterOptions = {};
      console.log("clear filter",this.requestBody)
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
    this.buyerUsersReportService
      .loader()
      .subscribe((val) => (this.loading = val));
  }
  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.buyerUsersReportService.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = { searchKey: event };
    } else {
      this.requestBody.searchOptions = undefined;
      this.buyerUsersReportService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    this.requestBody.sortOptions = event.direction === "" ? {} : { [`${event.active}`]: event.direction }
    await this.updateTable();
    this.buyerUsersReportService.loader().subscribe(val => (this.loading = val));
  }
}
